var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m184.134 348.072c0-91.341 74.704-165.234 166.348-163.916 88.771 1.277 160.954 74.078 161.516 162.856.314 49.718-21.511 94.339-56.19 124.605-3.66 3.194-3.133 9.023 1.048 11.497l30.89 18.276c4.994 2.955 2.897 10.611-2.905 10.609l-139.877-.034c-89.106-1.655-160.83-74.393-160.83-163.893z",
    fill: "#7acaa6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.744 501.391-30.89-18.276c-4.181-2.473-4.707-8.303-1.048-11.497 34.679-30.266 56.505-74.888 56.191-124.605-.561-88.778-72.745-161.579-161.516-162.856-6.042-.087-12.008.162-17.886.712 82.703 7.8 147.963 77.749 148.496 162.144.314 49.718-21.511 94.339-56.191 124.605-3.66 3.194-3.133 9.023 1.048 11.497l30.89 18.276c4.966 2.939 2.917 10.521-2.814 10.602l30.815.007c5.802.001 7.898-7.655 2.905-10.609z",
    fill: "#57be92"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m354.338 184.26c-1.282-.049-2.568-.086-3.857-.104-91.644-1.319-166.348 72.575-166.348 163.916 0 2.094.052 4.175.13 6.249 89.511-9.449 160.629-80.55 170.075-170.061z",
    fill: "#57be92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.866 163.933c0-91.341-74.704-165.234-166.348-163.916-88.77 1.278-160.953 74.079-161.515 162.857-.314 49.718 21.511 94.339 56.19 124.605 3.66 3.194 3.133 9.023-1.048 11.497l-30.89 18.276c-4.994 2.955-2.897 10.611 2.905 10.609l139.877-.034c89.105-1.656 160.829-74.394 160.829-163.894z",
    fill: "#8795de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.519.017c-4.383.063-8.724.307-13.019.712 83.281 7.797 148.461 77.884 148.461 163.204 0 89.5-71.725 162.238-160.829 163.894l-109.062.027c.031 0 .059.008.091.008l139.877-.034c89.104-1.656 160.829-74.394 160.829-163.894-.001-91.342-74.704-165.235-166.348-163.917z",
    fill: "#6c7fd8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 163.933,
    cy: 274.956,
    fill: "#fff",
    r: 17.214
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m163.932 226.878c-8.534 0-15.453-6.919-15.453-15.453v-55.03c0-8.534 6.919-15.453 15.453-15.453 10.288 0 19.861-4.116 26.957-11.59 7.091-7.468 10.7-17.263 10.165-27.582-1.004-19.329-16.969-34.776-36.346-35.166-18.868-.382-34.994 13.36-37.589 31.961-.239 1.71-.36 3.46-.36 5.204 0 8.534-6.919 15.453-15.453 15.453s-15.453-6.919-15.453-15.453c0-3.169.221-6.358.657-9.477 4.693-33.634 33.551-58.601 67.428-58.601.464 0 .927.005 1.391.014 35.5.715 64.748 29.031 66.588 64.464.98 18.867-5.632 36.789-18.616 50.464-9.196 9.686-21.07 16.403-33.916 19.42v41.373c0 8.533-6.918 15.452-15.453 15.452z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 348.067,
    cy: 348.069,
    r: 17.214
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.33,
    cy: 348.069,
    r: 17.214
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.803,
    cy: 348.069,
    r: 17.214
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.d5ad8bb643de69a823b9c7d141476a0d.svg";
export { ForwardRef as ReactComponent };